import { render, staticRenderFns } from "./MainWide.vue?vue&type=template&id=1d01250c&"
import script from "./MainWide.vue?vue&type=script&lang=js&"
export * from "./MainWide.vue?vue&type=script&lang=js&"
import style0 from "./MainWide.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports